const common = {
  title: "takkyu's blog",
  indexTitle: 'Main page',
  description: "Random thoughts on programming.",
  postFooter: "I welcome and appreciate any comment on my posts.",
  minToRead: "{{mins}} to read{{emoji}}",
}

export default common;
